import React from 'react';

import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	badge: {
		display: 'flex',
		height: '16px',
		minWidth: '24px',
		minHeight: '16px',
		paddingBlock: token('space.0'),
		paddingInline: token('space.050'),
		justifyContent: 'center',
		alignItems: 'center',
		flexShrink: 0,
		borderRadius: token('radius.xsmall'),
		backgroundColor: token('color.background.accent.gray.subtler'),
		font: token('font.body.small'),
		color: token('color.text.accent.gray'),
		boxSizing: 'border-box',
	},
});

export type SectionCountBadgeProps = {
	count: number;
	/** Renders the count as `count+`, for a section that has more items left to load. */
	hasMore?: boolean;
};

/**
 * How many items a preview-panel section holds, in the badge beside its title.
 *
 * Every section header shares this one component rather than styling a badge of its own — the
 * collapsible sections and `SectionHeader`'s `PressableGroup` sections look nothing alike
 * otherwise, but their counts have to read as the same thing.
 *
 * Presentational only: a caller that hides a zero count does so itself, since "no count" and
 * "a count of zero" are the caller's distinction to make.
 */
export const SectionCountBadge = ({
	count,
	hasMore = false,
}: SectionCountBadgeProps): React.JSX.Element => (
	<span css={styles.badge}>
		{count}
		{hasMore ? '+' : null}
	</span>
);
